(function (scope) {
  'use strict';
  function whatsappURL(message, email) {
    return 'https://wa.me/85261414775?text=' + encodeURIComponent(message.replace('{email}', email.trim()));
  }
  function placement(width, height, viewport) {
    return {left:viewport.left+viewport.width-width,top:Math.max(viewport.top+12,viewport.top+viewport.height-12-height)};
  }
  function anchorPlan(rects, ceiling, bottom) {
    if(!rects.length || rects.every(r=>r.bottom<=bottom))return [];
    const heights=rects.map(r=>Math.max(44,r.height));
    const total=heights.reduce((a,b)=>a+b,0);
    const gap=rects.length>1 ? Math.min(8,(bottom-ceiling-total)/(rects.length-1)) : 0;
    if(gap<4 && rects.length>1 || total>bottom-ceiling)return null;
    let y=bottom-total-gap*(rects.length-1);
    return heights.map(height=>{const top=y;y+=height+gap;return top;});
  }
  function createEmailRequester({endpoint, consentVersion, locale, marketCountry, fetcher, makeId, timeoutMs=15000, now=()=>Date.now(), setTimer=setTimeout, clearTimer=clearTimeout}) {
    let identity=null,pending=null,confirmed=null,terminal=null,retryAt=0;
    function reset(){if(!pending){identity=null;confirmed=null;terminal=null;}}
    function retryDelay(){return Math.max(0,retryAt-now());}
    async function submit(email,context={}){
      if(pending)return pending;
      const requestLocale=context.locale??locale,country=context.marketCountry??marketCountry;
      const digest=JSON.stringify([email.trim(),true,consentVersion,requestLocale,country,'v161-newsletter-popup']);
      if(!identity || identity.digest!==digest){identity={digest,id:makeId()};confirmed=null;terminal=null;}
      if(confirmed)return confirmed;
      if(terminal)return terminal;
      if(retryDelay())return {status:'rate_limit',retry_after_ms:retryDelay()};
      const body={request_id:identity.id,email:email.trim(),consent:true,consent_version:consentVersion,locale:requestLocale,market_country:country,source:'v161-newsletter-popup'};
      const encoded=JSON.stringify(body);
      if(!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(body.request_id) || !/^[A-Z]{2}$/.test(country||'') || !requestLocale || consentVersion!=='newsletter-email-20261007-v1' || new TextEncoder().encode(encoded).length>4096){terminal={status:'validation_error'};return terminal;}
      pending=(async()=>{
        const controller=new AbortController(),timer=setTimer(()=>controller.abort(),timeoutMs);
        try{
          const response=await fetcher(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',cache:'no-store',redirect:'error',signal:controller.signal,body:encoded});
          if(response.status===429){
            const raw=response.headers?.get('Retry-After')?.trim();
            let delay=raw && /^\d+$/.test(raw)?Number(raw)*1000:raw?Date.parse(raw)-now():NaN;
            if(!Number.isFinite(delay))delay=60000;
            retryAt=now()+Math.max(0,delay);
            return {status:'rate_limit',retry_after_ms:retryDelay()};
          }
          if([400,403,409,413,422].includes(response.status)){terminal={status:'validation_error'};return terminal;}
          if(!response.ok)return {status:'error'};
          const data=await response.json();
          if(data.request_id!==identity.id || !['accepted','queued','delivered'].includes(data.status))return {status:'error'};
          confirmed={status:data.status};return confirmed;
        }catch{return {status:'error'};}finally{clearTimer(timer);}
      })();
      try{return await pending;}finally{pending=null;}
    }
    return {submit,reset,retryDelay};
  }
  function createDialogFlow(formDialog, ackDialog, lock, unlock, focusTrigger) {
    let session=0,locked=false;
    function finish(){
      if(formDialog.open || ackDialog.open || !locked)return;
      locked=false;unlock();focusTrigger();
    }
    function open(){
      if(formDialog.open || ackDialog.open)return;
      session++;formDialog.showModal();
      if(!locked){locked=true;lock();}
    }
    function close(target){if(target.open)target.close();finish();}
    function acknowledge(status,token){
      if(!['accepted','queued','delivered'].includes(status) || token!==session || !formDialog.open)return false;
      // close events are queued: the old form event must not unlock the new modal.
      formDialog.close();ackDialog.showModal();return true;
    }
    return {open,close,finish,acknowledge,get session(){return session;}};
  }
  if (typeof module === 'object' && module.exports) module.exports = { whatsappURL, placement, anchorPlan, createEmailRequester, createDialogFlow };
  if (!scope.document) return;
  const root = scope.document.querySelector('[data-two-nu-newsletter]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const trigger = root.querySelector('[data-newsletter-open]');
  const dialog = root.querySelector('dialog');
  const ack = root.querySelector('[data-newsletter-ack]');
  const form = root.querySelector('form');
  const email = root.querySelector('[type=email]');
  const consent = root.querySelector('[type=checkbox]');
  const feedback = root.querySelector('[data-newsletter-feedback]');
  const copy = JSON.parse(root.querySelector('[data-newsletter-copy]').textContent);
  const emailButton=root.querySelector('[data-newsletter-email]');
  const waButton=root.querySelector('[data-newsletter-submit]');
  const emailConfig=JSON.parse(root.querySelector('[data-newsletter-email-config]').textContent);
  let endpoint=null;
  try{const url=new URL(emailConfig.endpoint,scope.location.href);if(emailConfig.enabled===true && emailConfig.endpoint && url.protocol==='https:' && !url.username && !url.password && emailConfig.consent_version==='newsletter-email-20261007-v1' && /^[A-Z]{2}$/.test(emailConfig.market_country||'') && scope.crypto?.randomUUID)endpoint=url.href;}catch{}
  const requester=endpoint?createEmailRequester({endpoint,consentVersion:emailConfig.consent_version,locale:emailConfig.locale,marketCountry:emailConfig.market_country,fetcher:scope.fetch.bind(scope),makeId:()=>scope.crypto.randomUUID()}):null;
  let emailPending=false,emailState='',retryTimer=null;
  emailButton.disabled=!requester;
  function renderEmailState(){
    const cooldown=requester?.retryDelay()||0;
    emailButton.disabled=!requester || emailPending || cooldown>0 || ['accepted','queued','delivered','validation_error'].includes(emailState);
    if(retryTimer)scope.clearTimeout(retryTimer);
    if(cooldown>0)retryTimer=scope.setTimeout(renderEmailState,Math.min(cooldown,2147483647));
    emailButton.textContent=copy[emailPending?'email_pending':['error','rate_limit'].includes(emailState)?'email_retry':'email_cta'];
    waButton.disabled=emailPending;
    emailButton.setAttribute('aria-busy',String(emailPending));
    form.setAttribute('aria-busy',String(emailPending));
    if(emailState)feedback.textContent=copy['email_'+emailState];
  }
  let frame, previousOverflow;
  const flow=createDialogFlow(dialog,ack,()=>{
    previousOverflow=scope.document.documentElement.style.overflow;
    scope.document.documentElement.style.overflow='hidden';
    trigger.setAttribute('aria-expanded','true');
  },()=>{
    scope.document.documentElement.style.overflow=previousOverflow;
    trigger.setAttribute('aria-expanded','false');
  },()=>{if(trigger.isConnected)trigger.focus({preventScroll:true});});
  function clearError() {
    email.removeAttribute('aria-invalid'); consent.removeAttribute('aria-invalid'); feedback.textContent = '';
  }
  trigger.addEventListener('click', () => {
    clearError(); if(emailState)renderEmailState(); flow.open();
    root.querySelector('[data-newsletter-close]').focus({preventScroll:true});
    layout();
  });
  root.querySelector('[data-newsletter-close]').addEventListener('click',()=>flow.close(dialog));
  ack.querySelectorAll('[data-newsletter-ack-close]').forEach(button=>button.addEventListener('click',()=>flow.close(ack)));
  [dialog,ack].forEach(surface=>{
    surface.addEventListener('click',e=>{
      if(e.target===surface){const r=surface.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)flow.close(surface);}
    });
    surface.addEventListener('cancel',e=>{e.preventDefault();flow.close(surface);});
    surface.addEventListener('close',flow.finish);
    surface.addEventListener('keydown',e=>{
      e.stopPropagation();
      if(e.key==='Escape'){e.preventDefault();flow.close(surface);}
      if(e.key==='Tab'){
        const items=[...surface.querySelectorAll('button,input,a[href]')].filter(n=>!n.disabled&&n.getClientRects().length);
        const first=items[0],last=items[items.length-1];
        if(e.shiftKey&&scope.document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&scope.document.activeElement===last){e.preventDefault();first.focus();}
      }
    });
  });
  function edited(){clearError();requester?.reset();emailState='';renderEmailState();}
  email.addEventListener('input',edited);consent.addEventListener('change',edited);
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if(emailPending)return;
    clearError(); email.value=email.value.trim();
    let invalid;
    if(!email.value) { feedback.textContent=copy.empty; invalid=email; }
    else if(!email.validity.valid) { feedback.textContent=copy.invalid; invalid=email; }
    else if(!consent.checked) { feedback.textContent=copy.consent_required; invalid=consent; }
    if(invalid) { invalid.setAttribute('aria-invalid','true'); invalid.focus(); return; }
    if(e.submitter===waButton || !e.submitter){
      feedback.textContent=copy.ready;
      scope.open(whatsappURL(copy.message,email.value),'_blank','noopener,noreferrer');
      return;
    }
    if(!requester){feedback.textContent=copy.email_unavailable;return;}
    const submissionSession=flow.session;
    emailPending=true;emailState='pending';email.disabled=true;consent.disabled=true;
    renderEmailState();
    try{const result=await requester.submit(email.value);emailState=result.status;}
    catch{emailState='error';}
    finally{emailPending=false;email.disabled=false;consent.disabled=false;renderEmailState();}
    if(flow.acknowledge(emailState,submissionSession))ack.querySelector('[data-newsletter-ack-done]').focus({preventScroll:true});
  });
  const arranged=new Map();
  const anchorSelector='a[data-dock-link],a[data-product-dock-link],a[data-two-nu-unified-anchor],.two-nu-page-dock > a[href^="#"]';
  function restoreAnchors(){
    for(const [node,old] of arranged){
      if(old.value)node.style.setProperty('top',old.value,old.priority);else node.style.removeProperty('top');
    }
    arranged.clear();
  }
  const selector = 'button,a[href],input[type=submit],input[type=button],[role=button]';
  function visibleRect(n){
    const style=scope.getComputedStyle(n),r=n.getBoundingClientRect();
    if(!n.getClientRects().length || style.visibility==='hidden' || style.display==='none' || style.pointerEvents==='none' || Number(style.opacity)===0 || n.closest('[hidden],[inert]') || r.width<=0 || r.height<=0)return null;
    return r;
  }
  function layout() {
    frame=null;
    const vv=scope.visualViewport;
    const v={left:vv?.offsetLeft||0,top:vv?.offsetTop||0,width:vv?.width||scope.innerWidth,height:vv?.height||scope.innerHeight};
    [dialog,ack].forEach(surface=>{
      surface.style.setProperty('--newsletter-height',Math.max(120,v.height-24)+'px');
      surface.style.setProperty('--newsletter-bottom',Math.max(0,scope.innerHeight-v.top-v.height)+'px');
    });
    const bottom=v.top+v.height;
    let floor=bottom;
    const dock=scope.document.querySelector('[data-two-nu-global-controls]');
    const dockRect=dock && visibleRect(dock);
    if(dockRect && dockRect.top>v.top && dockRect.top<bottom)floor=Math.min(floor,dockRect.top);
    const preview=scope.document.querySelector('#PBarNextFrameWrapper');
    if(preview){const r=preview.getBoundingClientRect();if(r.height>0 && r.height<v.height/2 && r.bottom>=bottom-2 && r.top<bottom)floor=Math.min(floor,r.top);}
    const safe=parseFloat(scope.getComputedStyle(root).paddingBottom)||0;
    floor=Math.min(floor,bottom-safe);
    const r=trigger.getBoundingClientRect();
    const p=placement(r.width,r.height,{...v,height:Math.max(0,floor-v.top)});
    trigger.style.right='0px';trigger.style.bottom='auto';trigger.style.left=p.left+'px';trigger.style.top=p.top+'px';
    // Read natural positions each pass, without transforming full-viewport nav containers.
    restoreAnchors();
    const links=[...scope.document.querySelectorAll(anchorSelector)]
      .filter(n=>scope.getComputedStyle(n).position==='fixed')
      .map(n=>({node:n,rect:visibleRect(n)}))
      .filter(x=>x.rect && x.rect.right>v.left+v.width-96 && x.rect.bottom>v.top && x.rect.top<floor)
      .sort((a,b)=>a.rect.top-b.rect.top);
    const plan=anchorPlan(links.map(x=>x.rect),v.top+80,p.top-12);
    root.dataset.anchorClearance=plan===null?'insufficient-space':plan.length?'reserved':'natural';
    if(plan?.length)links.forEach((x,i)=>{
      arranged.set(x.node,{value:x.node.style.getPropertyValue('top'),priority:x.node.style.getPropertyPriority('top')});
      x.node.style.setProperty('top',plan[i]+'px','important');
    });
    // Report actual text collisions; never move the coupon to the top to hide the problem.
    const paper={left:p.left+r.width-26,right:p.left+r.width,top:p.top,bottom:p.top+r.height};
    const conflicts=[...scope.document.querySelectorAll(selector)].filter(n=>!root.contains(n) && !n.disabled)
      .filter(n=>visibleRect(n)).filter(n=>{
        const walker=scope.document.createTreeWalker(n,4);
        while(walker.nextNode()){
          if(!walker.currentNode.textContent.trim())continue;
          const range=scope.document.createRange();range.selectNodeContents(walker.currentNode);
          if([...range.getClientRects()].some(t=>t.width>0&&t.height>0&&t.left<paper.right&&t.right>paper.left&&t.top<paper.bottom&&t.bottom>paper.top))return true;
        }
        return false;
      });
    root.dataset.couponTextConflicts=String(conflicts.length);
    root.dataset.couponHitConflicts=String([...scope.document.querySelectorAll(selector)].filter(n=>!root.contains(n) && !n.disabled).map(visibleRect).filter(t=>t && t.left<p.left+r.width && t.right>p.left && t.top<p.top+r.height && t.bottom>p.top).length);
    root.dataset.couponViewport= v.height < r.height+24 ? 'insufficient-space':'fits';

  }
  function schedule(){if(!frame)frame=scope.requestAnimationFrame(layout);}
  scope.addEventListener('resize',schedule,{passive:true});
  scope.addEventListener('scroll',schedule,{passive:true});
  scope.visualViewport?.addEventListener('resize',schedule,{passive:true});
  scope.visualViewport?.addEventListener('scroll',schedule,{passive:true});
  const observer=new ResizeObserver(schedule);
  observer.observe(scope.document.documentElement);
  const dockBar=scope.document.querySelector('[data-two-nu-global-controls]');
  if(dockBar)observer.observe(dockBar);
  const previewBar=scope.document.querySelector('#PBarNextFrameWrapper');
  if(previewBar)observer.observe(previewBar);
  scope.document.querySelectorAll(selector).forEach(n=>observer.observe(n));
  const discovery=new MutationObserver(schedule);
  discovery.observe(scope.document.documentElement,{childList:true,subtree:true});
  const viewportStyle=new MutationObserver(schedule);
  viewportStyle.observe(scope.document.documentElement,{attributes:true,attributeFilter:['style']});
  scope.addEventListener('load',schedule,{once:true});
  layout();
})(typeof window === 'undefined' ? globalThis : window);
